import brandTheme from './brandTheme'

const {
  colors: { primary, secondary },
} = brandTheme()
// http://www.color-blindness.com/color-name-hue/
export const theme = {
  colors: {
    primary,
    secondary,
    alabaster: '#F8F8F8',
    athensGray: '#E6EAEE',
    athensGray2: '#E4E5EC',
    darkAthensGray: '#969696',
    amaranth2: '#F42156',
    curiousBlue: '#1A91EB',
    dustyGray: '#979797',
    ebonyClay: '#1E232D',
    forestGreen: '#38BA24',
    seeGreen: '#22CDA4',
    iron: '#DFE2E5',
    oxfordBlue: '#354052',
    mystic: '#DFE4EE',
    regentGray: '#7F8FA4',
    regentGray2: '#8A96A0',
    regentGray3: '#7E8FA5',
    rebeccaPurple: '#663399',
    darkGray: '#02000D',
    silver: '#BBBBBB',
    silver2: '#D9D9D9',
    veryLightGrey: '#C7C7C7',
    white: '#FFFFFF',
    red: '#FF0000',
    green: '#00AE95',
    darkOrange: '#FF8C00',
    black: '#000000',
    yellow: '#eed202',
    disabled: '#E0E0E0',
    get placeholder() {
      return this.veryLightGrey
    },
  },
  fonts: {
    robotoMedium: '"Roboto Medium", Helvetica, Arial, sans-serif',
    robotoRegular: '"Roboto Regular", Helvetica, Arial, sans-serif',
    robotoBold: '"Roboto Bold", Helvetica, Arial, sans-serif',
  },
  fontSizes: {
    breadcrumbs: '14px',
    ambassadors: {
      addReview: '16px',
    },
    clients: {
      card: {
        name: '15px',
        link: '14px',
      },
      clientView: '16px',
    },
    campaigns: {
      card: {
        campaignName: '15px',
        clientName: '14px',
        bottom: '14px',
      },
      sections: {
        section: '15px',
      },
    },
    pickup: {
      table: {
        clientBlock: '20px',
      },
    },
    commonText: '16px',
    city: {
      card: {
        link: '14px',
        label: '10px',
      },
      headerNav: '14px',
      addEdit: '16px',
    },
    dropZone: {
      dropZoneLabel: '14px',
    },
    filterButton: '13px',
    filterDatePicker: {
      input: '14px',
      label: '14px',
    },
    header: {
      desktopButton: '16px',
      searchPlaceholder: '14px',
    },
    linkExternal: '16px',
    links: {
      linkPublish: '16px',
      linkCopyCreate: '16x',
    },
    materialUI: {
      datePicker: '14px',
      selectField: '14px',
    },
    modal: {
      modalTitle: '34px',
      modalButton: '16px',
    },
    pageTitle: '34px',
    sidebar: {
      desktop: '14px',
    },
    section: {
      sectionLabel: '14px',
      sectionTitle: '26px',
    },
    settings: {
      settingsTile: {
        label: '15px',
        link: '10px',
      },
    },
    form: {
      input: '14px',
      label: '16px',
      messageErrorInput: '12px',
      placeholder: '14px',
      submitButton: '14px',
    },
    table: {
      td: '14px',
      th: '11px',
    },
    tabs: {
      tab: '14px',
    },
    statusLabel: '10px',
  },
  zIndexes: {
    header: {
      headerWrapper: 3,
      topNavButton: {
        opacityBackground: -1,
      },
    },
    sidebar: {
      sidebarWrapper: 2,
    },
    mainContentWrapper: {
      background: -1,
      first: 1,
    },
    cities: {
      background: 0,
      content: 1,
    },
  },
  modalButtons: {
    confirm: {
      float: 'right',
      get backgroundColor() {
        return theme.colors.primary
      },
    },
    cancel: {
      float: 'left',
      get backgroundColor() {
        return theme.colors.regentGray
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/Assets/Styles/theme.js